import { TryParseString } from 'utils/parserUtils';

// Default coordinate fallback for devices with missing/invalid values.
const DEFAULT_COORDS = { lat: 0.0, lng: 0.0 };

// Parse coordinates/location strings and guard against invalid objects.
const normalizeCoordsValue = (value) => {
  const parsed = TryParseString(value);
  if (!parsed || typeof parsed !== 'object') return { ...DEFAULT_COORDS };
  return parsed;
};

// Ensure devices always have valid coordinates/location objects.
export const normalizeDevice = (device) => {
  if (!device || typeof device !== 'object') return device;
  return {
    ...device,
    coordinates: normalizeCoordsValue(device.coordinates),
    location: normalizeCoordsValue(device.location),
  };
};

// Normalize a collection of devices in one pass.
export const normalizeConnectedDevices = (devices = []) =>
  devices.map((device) => normalizeDevice(device));

// Normalize group shape to include a merged `devices` array.
export const normalizeGroup = (group) => {
  if (!group || typeof group !== 'object') return group;
  return {
    ...group,
    devices: [...(group.controllers || []), ...(group.devices || []), ...(group.auxDevices || [])],
  };
};

// Normalize a collection of groups in one pass.
export const normalizeGroups = (groups = []) => groups.map((group) => normalizeGroup(group));
